import './App.css';
import PasscodeUI from './components/PasscodeUI';

function App() {
  return (
   <PasscodeUI />
  );
}

export default App;
